import { NivalizOutboundTransactionTimerPickUpPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../../pudo/pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface NivalizUrnsAwaitingPickUpProps {
    accountId: string;
    navigateUrl?: string;
}

export const NivalizUrnsAwaitingPickUp = ({ accountId, navigateUrl }: NivalizUrnsAwaitingPickUpProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='platform.statistics.nivaliz.awaiting-pick-up.title'
                description='Title of the Nivaliz dashboard stacked bar showing urns awaiting pick-up grouped by waiting time'
                defaultMessage='Urns: Awaiting pick-up'
            />
        }
        Chart={NivalizOutboundTransactionTimerPickUpPendingWaitingDaysStackedBarChart}
    />
);
